import buttonGlobalPlayerLogin from '@/components/button-global-player-login/button-global-player-login.vue'
import playerMenu from './player-menu/player-menu.vue'

export default {
  components: {
    buttonGlobalPlayerLogin,
    playerMenu
  }
}
